export const branchOptions = [
    'Computer Science Engineering (CSE)',
    'Electronics and Communication Engineering (ECE)',
    'Electrical and Electronics Engineering (EEE)',
    'Mechanical Engineering (ME)',
    'Aeronautical Engineering',
    'Aerospace Engineering',
    'Agricultural Engineering',
    'Automobile Engineering',
    'Bachelor of Architecture (B.Arch)',
    'Bachelor of Arts (B.A)',
    'Bachelor of Business Administration (B.B.A)',
    'Bachelor of Business Management (B.B.M)',
    'Bachelor of Business Studies (B.B.S)',
    'Bachelor of Commerce (B.Com)',
    'Bachelor of Computer Applications (B.C.A)',
    'Bachelor of Computer Science (B.C.S)',
    'Bachelor of Economics (B.Econ)',
    'Bachelor of Education (B.Ed.)',
    'Bachelor of Hotel Management (B.H.M)',
    'Bachelor of Management Studies (B.M.S)',
    'Bachelor of Medicine and Bachelor of Surgery (M.B.B.S)',
    'Bachelor of Pharmacy (B.Pharmacy)',
    'Bachelor of Science (B.Sc.)',
    'Bachelor of Science in Computer Science (B.Sc. Computer Science)',
    'Biochemical Engineering',
    'Biomedical Engineering',
    'Biotechnology',
    'Ceramic Engineering',
    'Chartered Accountant (CA)',
    'Chemical and Alcohol Technology',
    'Chemical and Polymer Engineering',
    'Chemical Engineering (CHE)',
    'Civil Engineering (CE)',
    'Computational Engineering and Networking (CEN)',
    'Computer Integrated Design & Manufacturing',
    'Computer Science and Business Systems',
    'Computer Science and Engineering (Artificial Intelligence and Machine Learning - AI & ML)',
    'Computer Science and Engineering (Artificial Intelligence and Robotics)',
    'Computer Science and Engineering (Block Chain Technology)',
    'Computer Science and Engineering (Cloud Computing)',
    'Computer Science and Engineering (Cyber Security)',
    'Computer Science and Engineering (Data Science - DS)',
    'Computer Science and Engineering (Internet of Things - IoT)',
    'Computer Science and Information Systems',
    'Computer Science and Information Technology (CSIT)',
    'Computing and Information Technology',
    'Construction Engineering',
    'Corrosion Engineering',
    'Cryptographic Engineering',
    'Data Science',
    'Electrical and Communications Engineering',
    'Electrical and Information Engineering',
    'Electrical Engineering - Power & Automation',
    'Electrical Engineering (EE)',
    'Electronics and Computer Engineering',
    'Electronics and Electrical Communication Engineering',
    'Electronics and Instrumentation Engineering (EIE)',
    'Electronics and Telecommunication Engineering (ETE)',
    'Electronics Engineering - Design and Manufacturing',
    'Electronics Instrumentation and Control',
    'Energy Engineering',
    'Engineering Physics',
    'Environmental Engineering',
    'Food Engineering',
    'Genetic Engineering',
    'Geotechnical Engineering',
    'Industrial and Production Engineering (IPE)',
    'Industrial and Systems Engineering',
    'Industrial Engineering (IE)',
    'Information and Communication Technology',
    'Information Science and Engineering',
    'Information Technology (IT)',
    'Instrumentation Engineering',
    'Manufacturing Science and Engineering',
    'Manufacturing Technology',
    'Marine Engineering',
    'Materials Engineering',
    'Mechanical and Industrial Engineering',
    'Mechatronics Engineering',
    'Metallurgical and Materials Engineering (MME)',
    'Mining Engineering',
    'Molecular and Cellular Engineering',
    'Nano Technology Engineering',
    'Naval Architecture and Ocean Engineering',
    'Nuclear Engineering',
    'Ocean Engineering',
    'Polymer Science and Technology',
    'Power Engineering',
    'Production Engineering',
    'Robotics Engineering',
    'Telecommunication Engineering',
    'Textile Engineering',
    'Tool Engineering',
    'Diploma / Polytechnic',
    'ITI'
];

export const degreeBranchOptions = [
    'Bachelor of Architecture (B.Arch)',
    'Bachelor of Arts (B.A)',
    'Bachelor of Business Administration (B.B.A)',
    'Bachelor of Business Management (B.B.M)',
    'Bachelor of Business Studies (B.B.S)',
    'Bachelor of Commerce (B.Com)',
    'Bachelor of Computer Applications (B.C.A)',
    'Bachelor of Computer Science (B.C.S)',
    'Bachelor of Economics (B.Econ)',
    'Bachelor of Education (B.Ed.)',
    'Bachelor of Hotel Management (B.H.M)',
    'Bachelor of Management Studies (B.M.S)',
    'Bachelor of Medicine and Bachelor of Surgery (M.B.B.S)',
    'Bachelor of Pharmacy (B.Pharmacy)',
    'Bachelor of Science (B.Sc.)',
    'Bachelor of Science in Computer Science (B.Sc. Computer Science)'
];

export const engineeringBranchOptions = [
    'Computer Science Engineering (CSE)',
    'Electronics and Communication Engineering (ECE)',
    'Electrical and Electronics Engineering (EEE)',
    'Mechanical Engineering (ME)',
    'Aeronautical Engineering',
    'Aerospace Engineering',
    'Agricultural Engineering',
    'Automobile Engineering',
    'Biochemical Engineering',
    'Biomedical Engineering',
    'Biotechnology',
    'Ceramic Engineering',
    'Chemical and Alcohol Technology',
    'Chemical and Polymer Engineering',
    'Chemical Engineering (CHE)',
    'Civil Engineering (CE)',
    'Computational Engineering and Networking (CEN)',
    'Computer Integrated Design & Manufacturing',
    'Computer Science and Business Systems',
    'Computer Science and Engineering (Artificial Intelligence and Machine Learning - AI & ML)',
    'Computer Science and Engineering (Artificial Intelligence and Robotics)',
    'Computer Science and Engineering (Block Chain Technology)',
    'Computer Science and Engineering (Cloud Computing)',
    'Computer Science and Engineering (Cyber Security)',
    'Computer Science and Engineering (Data Science - DS)',
    'Computer Science and Engineering (Internet of Things - IoT)',
    'Computer Science and Information Systems',
    'Computer Science and Information Technology (CSIT)',
    'Computing and Information Technology',
    'Construction Engineering',
    'Corrosion Engineering',
    'Cryptographic Engineering',
    'Data Science',
    'Electrical and Communications Engineering',
    'Electrical and Information Engineering',
    'Electrical Engineering - Power & Automation',
    'Electrical Engineering (EE)',
    'Electronics and Computer Engineering',
    'Electronics and Electrical Communication Engineering',
    'Electronics and Instrumentation Engineering (EIE)',
    'Electronics and Telecommunication Engineering (ETE)',
    'Electronics Engineering - Design and Manufacturing',
    'Electronics Instrumentation and Control',
    'Energy Engineering',
    'Engineering Physics',
    'Environmental Engineering',
    'Food Engineering',
    'Genetic Engineering',
    'Geotechnical Engineering',
    'Industrial and Production Engineering (IPE)',
    'Industrial and Systems Engineering',
    'Industrial Engineering (IE)',
    'Information and Communication Technology',
    'Information Science and Engineering',
    'Information Technology (IT)',
    'Instrumentation Engineering',
    'Manufacturing Science and Engineering',
    'Manufacturing Technology',
    'Marine Engineering',
    'Materials Engineering',
    'Mechanical and Industrial Engineering',
    'Mechatronics Engineering',
    'Metallurgical and Materials Engineering (MME)',
    'Mining Engineering',
    'Molecular and Cellular Engineering',
    'Nano Technology Engineering',
    'Naval Architecture and Ocean Engineering',
    'Nuclear Engineering',
    'Ocean Engineering',
    'Polymer Science and Technology',
    'Power Engineering',
    'Production Engineering',
    'Robotics Engineering',
    'Telecommunication Engineering',
    'Textile Engineering',
    'Tool Engineering'
];
